//import axiosLoadingIndicatorFactory from '../axios-loading-indicator';
import axios from 'axios';
import handlers from './default-handlers';

export default {
    register(vue, parameters, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.register, parameters, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    requestPasswordReset(vue, email, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.passwordReset.request, { email }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    resetPassword(vue, code, password, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.passwordReset.reset, { code, password }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },

    activate(vue, code, cb, errorCb, finallyCb) {
        axios.post(window.kgkRoutes.activate, { code }, {

        }).then(handlers.then(cb)).catch(handlers.catch(errorCb, vue)).then(handlers.finally(finallyCb));
    },
}
